import React, { useContext } from 'react';
import './Header.css';
import { useAuth, AuthContext } from '../../app/auth/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const { state: { loggedIn } } = useAuth();
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();


  const logout = () => {
    dispatch({ type: 'LOGOUT' });

    navigate('/');
  }


  return (
    <header className="app-header">
      <h1>Welcome to S3 Hosted Website</h1>
      <p>
        This is a React TypeScript application hosted on AWS S3 with CloudFront distribution.
      </p>
      <nav>
        <button onClick={() => navigate('/gallery')}>Gallery</button>
        {loggedIn ? (
          <button onClick={logout}>Logout</button>
        ) : (
          <button onClick={() => navigate('/login')}>Login</button>
        )}
      </nav>
    </header>
  );
};

export default Header;
